import { useSelector } from 'react-redux';
import { selectWhitelabelEnvs } from 'selectors/whitelabelSelectors';

/**
 * useWhitelabelEnvs hook. Return whitelabel environment configuration from Redux state.
 * @returns {object} Environment configuration object.
 */
const useWhitelabelEnvs = () => {
  const env = useSelector(selectWhitelabelEnvs);
  return env;
};

export default useWhitelabelEnvs;
